<!--
 * @Description: 附件组件
 * @Author: wangwangwang
 * @Date: 2020-12-14 11:06:22
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-04-07 13:53:27
-->
<template>
  <section>
    <el-upload v-if="upload" :disabled="disabled" action="/resource/resources/upload" :show-file-list="false" :before-upload="beforeUpload" :on-success="filesuccess" :headers="upheader">
      <el-link v-if="type!=='look'" :underline="false" :disabled="disabled">选择附件</el-link><span v-if="type!=='look'" style="margin-let:10px">(只能上传{{fileMessage.fileType}})</span>
      <div slot="tip" class="el-upload__tip" style="color:red">*{{upload_tip}}</div>
    </el-upload>
    <div style="margin-top:10px;">
      <div v-for="(item, index) in files" :key="index" class="upload-item-text">
        <span>
          <i class="icon iconfont iconhome_icon_txt"></i>
          <span  @click="lookFileDetail(item.fileUrl ? item.fileUrl: item.filePath,fileMessage.watermark)">{{item.fileName}}</span>
          <a  class="el-link" @click="downFile(item.fileUrl ? item.fileUrl: item.filePath)">
                        <i class="el-icon-download" style="padding:0 10px"></i>
          </a>
          <!-- <a v-if="type ==='look'" :href="'https://lvshe.huashijc.com/file/' + (item.fileUrl ? item.fileUrl: item.filePath) " :download="item.fileName">{{item.fileName}}</a> -->
        </span>
        <span>
          <span>上传时间：{{item.createTime}}</span>
          <span v-show="!disabled && type!=='look'" class="table_link" style="cursor:pointer;margin-left:30px;" @click="delfile(index)">删除</span>
        </span>
      </div>
    </div>
  </section>
</template>
<script>
import { getToken, getUserId } from '@/utils/auth';
import { getFileDetails } from '@/api/common';
import { Loading } from 'element-ui';
import { UPLOAD_TIP } from "@/utils/utils";
let loadingInstance;
export default {
  props: {
    files: {
      type: Array,
      default: new Array()
    },
    fileCode: {
      type: String,
      default: 'settlementFile'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    upload: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: ''
    },

  },
  data() {
    return {
      fileMessage: {},
      upheader: {
        "access-token": getToken(),
        "user-id": getUserId(),
      },
      upload_tip:UPLOAD_TIP,
    }
  },
  methods: {
    //查看
    lookFileDetail(path,watermark) {
      let filePath = 'https://lvshe.huashijc.com/file/' + path;
      if (filePath.endsWith('.jpg') || filePath.endsWith('.png') || filePath.endsWith('.jpeg')) {
        let imgUrl = filePath;
        window.open(imgUrl, "_blank");
      } else {
        this.$wps(filePath,watermark);
      }
    },
    delfile(index) {
      this.$emit('deleteFile', index);
    },
    downFile(path) {
            let imgUrl = 'https://lvshe.huashijc.com/file/' + path;
            window.open(imgUrl, "_blank");
        },
    beforeUpload(file) {
      if (!this.fileMessage || !this.fileMessage ?.fileType) {
        this.$message.error('当前流程未配置附件，请配置后再进行上传');
        return false;
      }
      const fileTypes = file.name.split('.');
      const fileType = fileTypes[fileTypes.length-1];
      const isTYPE = this.fileMessage.fileType.indexOf(fileType) > -1;
      const isLtM = file.size / 1024 / 1024 < this.fileMessage.trillionSize;
      if (!isTYPE) {
        this.$message.error('文件格式只能为' + this.fileMessage.fileType);
        return false;
      }
      if (!isLtM) {
        this.$message.error(`文件大小不能超过${this.fileMessage.trillionSize}M`);
        return false;
      }
      loadingInstance = Loading.service({ text: '上传中...' });
      return true;
    },
    filesuccess(res) {
      if (res.code === 1001) {
        this.$emit('uplodeSuccess', res.data);
        loadingInstance.close();
      }
    },
  },
  mounted() {
    getFileDetails({ code: this.fileCode }).then(res => {
      if (res.code === 1001) {
        console.log(res.data)
        this.fileMessage = res.data;
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.upload-item-text {
  cursor: pointer;
  padding: 0px 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  line-height: 30px;
  position: relative;
  > span:nth-of-type(2) {
    display: inline-block;
    width: 330px;
    position: absolute;
    // right: 0;
  }
  a {
    color: $bg_color;
    font-size: 14px;
    padding-right: 10px;
    text-decoration: none;
  }
  .iconhome_icon_txt {
    color: $bg_color;
    font-size: 14px;
    padding-right: 10px;
  }
  .iconzu2197:hover {
    color: $bg_color;
  }
  .iconzu2197 {
    color: #c0c4cc;
    font-size: 14px;
  }
}
.el-link {
  color: $bg_color;
}
.el-link:hover {
  color: $bg_color;
  opacity: 0.7;
}
</style>
